enum pageRoutes {
  // initial
  START_PAGE = "/panel/dashboard",
  // panel
  PANEL = "/panel",
  DASHBOARD = "/panel/dashboard",
  MEETING_REQUEST = "/panel/meeting_request",
  GROUP_THERAPY = "/panel/group-therapy",
  GROUP_THERAPY_REQUEST = "/panel/group-therapy/:group_therapy",
  MEETING_HISTORY = "/panel/meeting_history",
  GROUP_THERAPY_HISTORY = "/panel/group-therapy-history",
  PURCHASE_HISTORY = "/panel/purchase_history",
  MESSAGES = "/panel/messages",
  PROFILE = "/panel/profile",
  USER_MANAGEMENT = "/panel/users",
  CALENDAR = "/panel/calendar/:therapist",
  TERMS_OF_SERVICES = "/panel/terms_of_services",
  TERMS_OF_SERVICES_GROUP_THERAPY = "/panel/terms-of-services-group-therapy",
  EMAILS = "/panel/emails",
  ADMIN = "/panel/admin-page-fbey26",

  // auth
  REGISTER = "/auth/register",
  SIGNUP = "/auth/signup",
  LOGIN = "/auth/login",
  LOGIN_OTP = "/auth/login-mobile",
  FORGET_PASSWORD = "/auth/forget-password",
  // error
  ER404 = "/error/404",
  ER403 = "/error/403",
  ER500 = "/error/500",
  // test
  test = "/test",
}

export { pageRoutes };
